import Adicionar from './Adicionar';
import Assinar from './Assinar';
import Default from './Default';
import Editar from './Editar';
import Historico from './Historico';

const RelogiosDePontoDefault = Default;

export default RelogiosDePontoDefault;
export const RelogiosDePontoAdicionar = Adicionar;
export const RelogiosDePontoEditar = Editar;
export const RelogiosDePontoHistorico = Historico;
export const RelogiosDePontoAssinar = Assinar;
